import { Box, Tab, Tabs } from "@mui/material";
import pluralize from "pluralize";
import useColors from "../../../../../../api/hooks/useColors";
import iconMapping from "../../../../../../icons/IconMapping";
import { getEntityTypeDisplayName } from "../../../../../../utils/utils";

export default function EntityTypeTabs({
  entitiesByTabs,
  selectedEntityTypeTab,
  setSelectedEntityTypeTab,
}) {
  const colors = useColors();
  return (
    <Tabs
      value={selectedEntityTypeTab}
      onChange={(_, newValue) => {
        setSelectedEntityTypeTab(newValue);
      }}
      sx={{
        ".MuiTabs-indicator": {
          display: "none",
          boxShadow: "0px 0px 15px 2px " + colors.wizard_box_shadow,
        },
      }}
    >
      {Object.keys(entitiesByTabs).map((entityType) => {
        const Icon = iconMapping[entityType] || iconMapping["Internet"];

        const entitiesGroupedByTypeOnly = Array.isArray(
          entitiesByTabs[entityType]
        );

        const entityCount = entitiesGroupedByTypeOnly
          ? entitiesByTabs[entityType].length
          : // Handles case of entities grouped by type and by exclusion
            Object.values(entitiesByTabs[entityType]).reduce(
              (sum, arr) => sum + (Array.isArray(arr) ? arr.length : 0),
              0
            );

        return (
          <Tab
            key={entityType}
            value={entityType}
            disableRipple
            label={
              <Box display="flex" alignItems="center" gap={1}>
                <Icon
                  style={{
                    color: colors.text_primary,
                    width: "20px",
                    height: "20px",
                  }}
                />
                {`${pluralize(
                  getEntityTypeDisplayName(entityType)
                )} (${entityCount})`}
              </Box>
            }
            sx={{
              "&.Mui-selected": {
                boxShadow: "0px 0px 15px 2px rgba(0,0,0,0.2)",
              },
              fontWeight: entityType === selectedEntityTypeTab ? 500 : 400,
              borderRadius: "8px 8px 0 0",
              textTransform: "none",
              minHeight: "48px",
            }}
          />
        );
      })}
    </Tabs>
  );
}
